import {
  IconCopyright,
} from "@tabler/icons-react";

import LinkedinLogo from "../svgs/LinkedinLogo";
import FacebookLogo from "../svgs/FacebookLogo";
import YoutubeLogo from "../svgs/YoutubeLogo";
import InstagramLogo from "../svgs/InstagramLogo";

import { Separator } from "@/components/ui/separator";
import { useTranslations } from "../helpers/translations";
import React from "react";

export const SubFooter: React.FC = () => {
  const t = useTranslations("footer");

  const currentYear = new Date().getFullYear();

  const internalLinks = [
    { href: "/terms-of-use", text: t("terms") },
    { href: "/privacy-policy", text: t("privacy") },
    { href: "/security", text: t("security") },
    { href: "/product-policy", text: t("product_policy") },
  ];

  const socialLinks = [
    {
      href: "https://www.linkedin.com/company/vention/",
      icon: <LinkedinLogo/>,
    },
    {
      href: "https://www.facebook.com/vention.io",
      icon: <FacebookLogo />,
    },
    {
      href: "https://www.instagram.com/vention.io/",
      icon: <InstagramLogo />,
    },
    {
      href: "https://www.youtube.com/channel/UCwCbtvoW8A3KrASjN5X2KrQ",
      icon: < YoutubeLogo/>,
    },
  ];

  return (
    <div className="bg-gray-light-800">
      <div className="container pb-7xl">
        <Separator className="bg-base-white" />
        <div className="text-xs-regular flex items-center justify-between pt-xl flex-col space-y-3xl sm:flex-row sm:space-y-0">
          <div className="flex items-center flex-wrap gap-x-xl w-full grow sm:justify-start">
            <a
              href="/"
              className="flex items-center py-md lg:py-0 space-x-md text-xs-medium text-primary-on-brand no-underline hover:no-underline hover:text-primary-on-brand"
            >
              <IconCopyright size={14} />
              <div>Vention {currentYear}</div>
            </a>

            {internalLinks.map((link, index) => (
              <a
                className="text-xs-medium text-primary-on-brand py-md lg:py-0 no-underline hover:no-underline hover:text-primary-on-brand"
                key={index}
                href={link.href}
              >
                {link.text}
              </a>
            ))}
          </div>

          <div className="flex justify-between w-full sm:w-auto sm:justify-end sm:gap-x-4xl">
            {socialLinks.map((link, index) => (
              <a
                className="fill-base-white no-underline hover:no-underline hover:fill-brand-200 transition-all duration-150 ease-linear focus:fill-base-white"
                target="_blank"
                rel="noreferrer noopener"
                key={index}
                href={link.href}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
